import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiCommentsModule } from '@components/ui-comment/ui-comments.module';
import { UiDateTimePickerModule } from '@components/ui-datetime-picker/ui-datetime-picker.module';
import { UiJsonFormatterModule } from '@components/ui-json-formatter/ui-json-formatter.module';
import { UiToggleSwitchModule } from '@components/ui-toggle-switch/ui-toggle-switch.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { ReviewTransactionsPageComponent } from '@pages/transactions/review-transactions.page';
import { TransactionsPageComponent } from '@pages/transactions/transactions.page';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiDragAndDropModule } from '@uipath/angular/directives/ui-drag-and-drop-file';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import {
    TransactionAttemptsGridComponent,
    TransactionEventsGridComponent,
    TransactionsItemsGridComponent,
} from './grids';
import {
    TransactionDetailsModalComponent,
    TransactionReviewerModalComponent,
    TransactionUpsertModalComponent,
} from './modals';

const MODALS = [
    TransactionDetailsModalComponent,
    TransactionReviewerModalComponent,
    TransactionEventsGridComponent,
    TransactionUpsertModalComponent,
];

const LOCAL_COMPONENTS = [
    TransactionAttemptsGridComponent,
    TransactionsItemsGridComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiGridModule,
        UiGridResetModule,
        UiJsonFormatterModule,
        UiCommentsModule,
        UiSuggestModule,
        UiNgLetModule,
        UiDateFormatModule,
        UiSpinnerButtonModule,
        UiDateTimePickerModule,
        UiDragAndDropModule,
        UiToggleSwitchModule,
    ],
    declarations: [
        TransactionsPageComponent,
        ReviewTransactionsPageComponent,
        ...LOCAL_COMPONENTS,
        ...MODALS,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class TransactionModule { }
